import React from 'react';
import Header from '../components/Header';
import ServicesComponent from '../components/Services';
import Footer from '../components/Footer';

const Services = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServicesComponent />
      </main>
      <Footer />
    </div>
  );
};

export default Services;